import React, { useEffect, useRef } from "react";
import { base44 } from "@/api/base44Client";

export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        window.location.replace("/login");
        return;
      }
      try {
        await base44.auth.createSession(sessionId);
        window.location.replace("/Dashboard");
      } catch (e) {
        window.location.replace("/login");
      }
    })();
  }, []);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-slate-50 gap-4">
      <div className="w-8 h-8 border-4 border-slate-200 border-t-brand-ink rounded-full animate-spin" />
      <p className="text-sm text-slate-500">Logger deg inn...</p>
    </div>
  );
}
